// modal/detail/ui/TabPanel.jsx
import React from 'react';

export function TabPanel({ value, index, children }) {
  // keep-mounted: sadece display none
  return <div style={{ display: value === index ? 'block' : 'none' }}>{children}</div>;
}
